import { render } from "./ListTrashPlaylistVideoView.vue?vue&type=template&id=3699d568"
import script from "./ListTrashPlaylistVideoView.vue?vue&type=script&lang=js"
export * from "./ListTrashPlaylistVideoView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__